export default __webpack_public_path__ + "static/media/user.94077278.svg";